import React from "react";
import { accentMap, formatNumber } from "./rootDashboardUtils";

export default function RootKpis({ kpis = [] }) {
  const anchorMap = {
    sesiones_activas: "root-sessions-recent",
    usuarios_sesion_hoy: "root-access-recent",
    usuarios_bloqueados: "root-logs",
    resets_pendientes: "root-resets",
  };

  const handleJump = (anchorId) => {
    if (!anchorId || typeof document === "undefined") return;
    const target = document.getElementById(anchorId);
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="management-card root-summary-wrapper mb-4">
      <div className="root-summary-grid">
        {kpis.map((kpi) => {
          const anchorId = anchorMap[kpi.key];
          const clickable = Boolean(anchorId);
          return (
            <div className="w-100" key={kpi.key || kpi.label}>
              <div
                className={`management-stat-card root-summary-card h-100 ${
                  clickable ? "is-clickable" : ""
                }`}
                role={clickable ? "button" : undefined}
                tabIndex={clickable ? 0 : undefined}
                onClick={clickable ? () => handleJump(anchorId) : undefined}
                onKeyDown={
                  clickable
                    ? (event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          handleJump(anchorId);
                        }
                      }
                    : undefined
                }
              >
                <div
                  className="management-stat-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-shield-check"}`} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{kpi.label}</p>
                  <div className="management-stat-value">{formatNumber(kpi.value)}</div>
                  <div className="root-summary-helper text-muted">{kpi.helper}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
